import Link from "next/link"
import { type CoralConfigOptions } from "@octopus-energy/coral/atoms"
import { type IconProps } from "@octopus-energy/icons"

export const config: CoralConfigOptions = { LinkComponent: Link }
export const coralIconConfig = { size: 20 } satisfies IconProps
